import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate, useLocation, useParams, Navigate } from 'react-router-dom'
import { app, performAssessments } from 'router/routes'
import { PerformAssessmentStyles } from './Style'
import { Img } from 'styles/GlobalStyle'
import { Glitter } from 'assets'
import { AnimatePresence } from "motion/react"
import { AbilityContext } from 'components/Permissions/Can'
import { performAssessmentHooks, RatingList } from '.'
import { map, takeRight } from 'lodash'
import { glitter, assessment_progress1, assessment_progress2, assessment_progress3, assessment_progress4, assessment_progress5, assessment_progress6, assessment_progress7 } from 'introductions'
import ReactPlayer from 'react-player'
import * as motion from "motion/react-client"


const BetweenAssessmentsScreen = () => {
    // תפקיד המסך  לקבל רשימה של ids 
    // ולהעביר לראשון ברשימה
    const [playComplimentAudio, setPlayComplimentAudio] = useState(false)

    const navigate = useNavigate()
    const ability = useContext(AbilityContext)
    const { assessmentID } = useParams()
    const { state } = useLocation()
    const { basePath, totalAssessmentsCount, isMaleGender, isHighGrade, remainingAssessmentIds, testTakerName = "", completedAssessmentsCount = 1 } = state || {}

    const ratings = performAssessmentHooks.useRatings()
    const ratings2 = map(ratings)
    const assessmentRatings = takeRight(ratings2, totalAssessmentsCount)

    const isLastAssessment = assessmentID == "complete"

    const steps = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי"]
    const audio = [assessment_progress2, assessment_progress3, assessment_progress1, assessment_progress4, assessment_progress5, assessment_progress6, assessment_progress7]
    const labels = ["איזה עבודה מעולה!", "איזו התמדה!", "איזה יופי, התקדמות מדהימה!", "אליפות, סיימנו עוד מבדק", "התקדמות של אלופים!", "כל הכבוד על הריכוז וההשקעה", "התקדמות יוצאת דופן!"]

    const onEndedAudio = useCallback(() => {
        setTimeout(() => {
            if (isLastAssessment)
                navigate(`/complete-screen`, {
                    state: {
                        basePath: basePath,
                        isMaleGender: isMaleGender,
                        totalAssessmentsCount: totalAssessmentsCount,
                        isHighGrade: isHighGrade
                    }
                })
            else
                navigate(`${basePath}/${assessmentID}`, {
                    state: {
                        basePath: basePath,
                        remainingAssessmentIds: remainingAssessmentIds,
                        assessmentPerformStep: completedAssessmentsCount + 1,
                        totalAssessmentsCount: totalAssessmentsCount,
                    }
                })
        }, 3000)
    }, [state, assessmentID])

    if (!state) {
        return <Navigate to={app.performAssessments} replace />;
    }

    return (
        <PerformAssessmentStyles>
            <motion.div
                className='between-img'
                initial={{ y: -120, opacity: 0, scale: 0.95 }}
                animate={{ y: 0, opacity: 1, scale: 1 }}
                transition={{
                    duration: 4,
                    ease: [0.22, 1, 0.36, 1] // cubic-bezier רך
                }}
            >
                <Img src={Glitter} />
            </motion.div>
            <AnimatePresence mode="wait">
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ y: 1, x: 1, opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                    className='between-animation'
                    key="between-animation"
                >
                    <div className='between-content'>
                        <motion.div
                            className='rating-img'
                            initial={{ scale: 0.4, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{
                                duration: 1.2,
                                ease: "easeOut"
                            }}
                        >
                            <Img src={assessmentRatings[completedAssessmentsCount - 1]?.iconOn} />
                        </motion.div>
                        <div className='between-title'>
                            {`${testTakerName} ${labels?.[completedAssessmentsCount - 1]}`}
                        </div>
                        <div className='between-sub-title'>
                            {isLastAssessment ?
                                "סיימת את כל המשימות" :
                                `סיימת שלב ${steps?.[completedAssessmentsCount - 1] || "נוסף"}`
                            }
                        </div>
                        <div className='ratings-between-screen'>
                            <RatingList ratings={assessmentRatings} completeIndex={completedAssessmentsCount} />
                        </div>
                    </div>
                </motion.div>
            </AnimatePresence>
            <ReactPlayer
                playing={true}
                url={glitter}
                controls={true}
                width='0px' height='0px'
                // onEnded={() => setPlayComplimentAudio(true)}
                onEnded={onEndedAudio}
            />
            {/* <ReactPlayer
                playing={playComplimentAudio}
                url={audio?.[completedAssessmentsCount - 1]}
                controls={true}
                width='0px' height='0px'
                onEnded={onEndedAudio}
            /> */}
        </PerformAssessmentStyles>
    )
}

export default BetweenAssessmentsScreen